export function fetch() { return { type: 'CONTACT/FETCH' } }


// WEBPACK FOOTER //
// ./src/redux-sagas/actions/contactEmailList.js